import { gql } from '@apollo/client';

const SettlementCardFragments = {
  TimelineCard: gql`
    fragment SettlementCard on TimelineCard {
      __typename
      ... on SettlementCard {
        role
        is_complete
        prices {
          cleanPriceCents
          dirtyPriceCents
          isVisibleToBuyer
        }
      }
    }
  `,
};

export default SettlementCardFragments;
